import { render, staticRenderFns } from "./cardSmsSession.vue?vue&type=template&id=a01486b4&"
import script from "./cardSmsSession.vue?vue&type=script&lang=js&"
export * from "./cardSmsSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports